import { HttpClient } from "./types";

export const createCouponService = (httpClient: HttpClient) => {
    const getEndpoint = (url: string): string => `/cupones${url}`;

    return {
        validateCoupon: <TRequest = any, TResponse = any>(
            couponCode: string,
            request: TRequest,
        ): Promise<TResponse> => {
            return httpClient.post<TResponse>(getEndpoint(`/${couponCode}/validar`), request);
        },
    };
};
